import { Outlet, useNavigate, Link } from 'react-router-dom';
import { LogOut, LayoutDashboard, Settings } from 'lucide-react';
import { motion } from 'framer-motion';

import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import api from '../../services/api';

export default function PanelLayout() {
    const { user, logout } = useAuth();
    const { isDark } = useTheme(); // Force dark mode if needed, but styling will handle it
    const navigate = useNavigate();

    function handleLogout() {
        logout();
        navigate('/login', { replace: true });
    }

    return (
        <div className="h-screen w-full bg-background text-primary overflow-hidden">
            <Outlet />
        </div>
    );
}
